<mat-table matSort [dataSource]="dataSource" id="header-location">
  <ng-container *ngFor="let column of columns" [matColumnDef]="column.columnDef">
    <mat-header-cell *matHeaderCellDef mat-sort-header id="{{column.columnDef}}Header"
                     [ngClass]="column.columnType !== ColumnType.NODE_NAME && column.columnType !== ColumnType.LOCATION
                      ? 'numeric' : 'node'"
                     (click)="onHeaderSortSelected(column)">
      <span class="header-text">{{column.header}}</span>
    </mat-header-cell>
  </ng-container>
  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
</mat-table>
